<template>
    <div class="box box-rose widget widget--downline-orders" id="widgets.downline-orders" :class="{'collapsed-box': expanded == 0}">
        <div class="div-preloader"><div class="div-status"></div></div>
        <div class="box-header with-border">
            <h3 class="box-title" v-if="week && year">{{ _t('Downline orders') }} - {{ week }}/{{ year }}</h3>
            <h3 class="box-title" v-if="!week && !year">{{ _t('Downline orders') }} </h3>
            <div class="legend">
                <a href="javascript: return false;" onclick="javascript: return false;" class="btn btn-info btn-xs">
                    <i class="fa fa-paper-plane"></i>
                </a> {{ _t('Send orders') }}&nbsp;
                <a href="javascript: return false;" onclick="javascript: return false;" class="btn btn-primary btn-xs">
                    <i class="fa fa-eye"></i>
                </a> {{ _t('View') }}&nbsp;
                <a href="javascript: return false;" onclick="javascript: return false;" class="btn btn-success btn-xs">
                    <i class="fa fa-shopping-cart"></i>
                </a>
                <a href="javascript: return false;" onclick="javascript: return false;" class="btn btn-warning btn-xs">
                    <i class="fa fa-shopping-cart"></i>
                </a>
                <a href="javascript: return false;" onclick="javascript: return false;" class="btn btn-default disabled btn-xs">
                    <i class="fa fa-shopping-cart"></i>
                </a>
                <a href="javascript: return false;" onclick="javascript: return false;" class="btn btn-danger disabled btn-xs">
                    <i class="fa fa-shopping-cart"></i>
                </a> {{ _t('Order') }}
            </div>

            <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse">
                    <i class="fa fa-minus" v-if="expanded != 0"></i>
                    <i class="fa fa-plus" v-if="expanded == 0"></i>
                </button>
            </div>
        </div>
        <div class="box-body">
            <ol class="breadcrumb">
                <li>
                    <a href="#" @click.prevent="getDownline(endPoint, true); sliceBreadCrumbs(); downlineOrdersChanged()">
                        <img src="/images/app/logo-mini-2.png" class="img-responsive" style="max-width: 25px; height: auto;">
                        <span class="all-downline-orders">{{ _t('All') }}</span>
                    </a>
                </li>
                <li v-for="(breadCrumb, index) in breadCrumbs">
                    <a href="#" @click.prevent="getDownline(breadCrumb.url, false);  sliceBreadCrumbs(index); downlineOrdersChanged(breadCrumb.username, breadCrumb.user_id, breadCrumb.fullname)">{{ breadCrumb.text }}</a>
                </li>
            </ol>
            <div class="table-container">
                <table class="table no-margin widget--downline-orders__table" v-if="downlineOrders">
                    <thead>
                        <tr class="widget--downline-orders__header-row">
                            <th>
                                {{ _t('Consultant') }}
                                <input type="search"
                                    class="form-control widget--downline-orders__search"
                                    :placeholder="_t('Search...')"
                                    v-model="searchString"
                                    @input="search"
                                    >
                            </th>
                            <th></th>
                            <th class="text-center text-red">{{ _t('Not paid N°') }}</th>
                            <th class="text-center text-aqua">{{ _t('Sent N°') }}</th>
                            <th class="text-right text-darkorange">{{ _t('Drafts A1') }}</th>
                            <th class="text-right text-light-blue">{{ _t('Closed A1') }}</th>
                            <th class="text-right text-aqua">{{ _t('Sent A1') }}</th>
                            <th class="text-right">{{ _t('Total A1') }}</th>
                            <th class="text-right">{{ _t('Total C1') }}</th>
                        </tr>
                        <tr class="main-row widget--downline-orders__row" v-if="downlineOrders.length">
                            <td>
                                <strong style="margin-right: 2px;">{{ _t('Total') }}</strong>
                                <i class="fa fa-circle online-offline" v-if="totalLine.userActivityStatus" :class="{'text-success': totalLine.userActivityStatus == 'active', 'text-danger': totalLine.userActivityStatus == 'offline', 'text-yellow': totalLine.userActivityStatus == 'inactive'}"></i>
                                <strong>{{ totalLine.totalUser }}</strong>
                            </td>
                            <td class="text-right">
                                <a href="#" class="btn btn-info"
                                    :class="{'disabled': ordersDisabled}"
                                    @click="sendConfirmedOrders($event, totalLine.massiveSendingRoute)"
                                    v-if="totalLine.massiveSending" :title="_t('Send orders')"><i class="fa fa-paper-plane"></i></a>
                                <span slot="createButton" v-html="totalLine.createButton">{{ totalLine.createButton }}</span>
                            </td>
                            <td class="text-center text-red">
                                <strong>{{ formatterInteger.format(totalLine.notPaidCount) }}</strong>
                            </td>
                            <td class="text-center text-aqua">
                                <strong>{{ formatterInteger.format(totalLine.sentCount) }}</strong>
                            </td>
                            <td class="text-right text-darkorange">
                                <strong>{{ formatter.format(totalLine.draftTotal) }}€</strong>
                            </td>
                            <td class="text-right text-light-blue">
                                <strong>{{ formatter.format(totalLine.confirmedTotal) }}€</strong>
                            </td>
                            <td class="text-right text-aqua">
                                <strong>{{ formatter.format(totalLine.sentTotal) }}€</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{ formatter.format(totalLine.draftTotal + totalLine.confirmedTotal + totalLine.sentTotal ) }}€</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{ formatter.format(totalLine.totalC1) }}€</strong>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(order, index) in downlineOrders" class="widget--downline-orders__row">
                            <td class="" :class="{'text-danger': order.user_state == 'disabled'}">
                                <table>
                                    <tr>
                                        <td rowspan="3" class="text-center">
                                            <img :src="order.profile_image" class="user-image">
                                        </td>
                                        <td class="user-fullname">
                                            <i class="fa fa-circle online-offline" :class="{'text-success': order.user_activity_status == 'active', 'text-danger': order.user_activity_status == 'offline', 'text-yellow': order.user_activity_status == 'inactive'}"></i>
                                            <a :href="order.view_user_route" target="_blank">{{ order.fullname }}</a>
                                            ({{ order.consultant_group_external_code }})
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="user-cellphone">
                                            <i class="fa fa-phone-square"></i>
                                            <a :href="'tel:' + order.cellphone">{{ order.cellphone }}</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="user-email">
                                            <i class="fa fa-envelope"></i>
                                            <a :href="'mailto:' + order.email">{{ order.email }}</a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">
                                            <strong>{{ order.username }}</strong>
                                        </td>
                                        <td class="user-last-order">
                                            <i class="fa fa-shopping-cart"></i>
                                            {{ order.last_processed_order }}
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td class="text-right">
                                <a href="#" class="btn btn-info" :class="{'disabled': ordersDisabled}" @click="sendConfirmedOrders($event, order.massive_send_route)" v-if="order.massive_sending" :title="_t('Send orders')"><i class="fa fa-paper-plane"></i></a>
                                <a href="#"
                                   @click.prevent="getDownline(order.next_level_url, false, $event);
                                   pushBreadCrumb(order.next_level_url, order.fullname, order.consultant_group_external_code, order.username, order.user_id, order.massive_send_route, order.massive_sending);
                                   downlineOrdersChanged(order.username, order.user_id, order.fullname)"
                                   class="btn btn-primary" v-if="order.next_level_url" :title="_t('View')"><i class="fa fa-eye"></i></a>
                                <span slot="createButton" v-html="order.create_button">{{ order.create_button }}</span>
                            </td>
                            <td class="text-center text-red">{{ formatterInteger.format(Number(order.not_paid_orders_count)) }}</td>
                            <td class="text-center text-aqua">{{ formatterInteger.format(Number(order.sent_orders_count)) }}</td>
                            <td class="text-right text-darkorange">{{ formatter.format(order.draft_orders_total) }}€</td>
                            <td class="text-right text-light-blue">{{ formatter.format(order.confirmed_orders_total) }}€</td>
                            <td class="text-right text-aqua">{{ formatter.format(order.sent_orders_total) }}€</td>
                            <td class="text-right">{{ formatter.format(Number(order.draft_orders_total) + Number(order.confirmed_orders_total) + Number(order.sent_orders_total)) }}€</td>
                            <td class="text-right">{{ formatter.format(order.total_c1) }}€</td>
                        </tr>
                        <tr v-if="!downlineOrders.length" class="widget--downline-orders__row">
                            <td colspan="10" class="text-center">
                                {{ _t('No entries in table') }}
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="main-row widget--downline-orders__row" v-if="downlineOrders.length">
                            <td>
                                <strong style="margin-right: 2px;">{{ _t('Total') }}</strong>
                                <i class="fa fa-circle online-offline" v-if="totalLine.userActivityStatus" :class="{'text-success': totalLine.userActivityStatus == 'active', 'text-danger': totalLine.userActivityStatus == 'offline', 'text-yellow': totalLine.userActivityStatus == 'inactive'}"></i>
                                <strong>{{ totalLine.totalUser }}</strong>
                            </td>
                            <td class="text-right">
                                <a href="#" class="btn btn-info"
                                    :class="{'disabled': ordersDisabled}"
                                    @click="sendConfirmedOrders($event, totalLine.massiveSendingRoute)"
                                    v-if="totalLine.massiveSending" :title="_t('Send orders')"><i class="fa fa-paper-plane"></i></a>
                                <span slot="createButton" v-html="totalLine.createButton">{{ totalLine.createButton }}</span>
                            </td>
                            <td class="text-center text-red">
                                <strong>{{ formatterInteger.format(totalLine.notPaidCount) }}</strong>
                            </td>
                            <td class="text-center text-aqua">
                                <strong>{{ formatterInteger.format(totalLine.sentCount) }}</strong>
                            </td>
                            <td class="text-right text-darkorange">
                                <strong>{{ formatter.format(totalLine.draftTotal) }}€</strong>
                            </td>
                            <td class="text-right text-light-blue">
                                <strong>{{ formatter.format(totalLine.confirmedTotal) }}€</strong>
                            </td>
                            <td class="text-right text-aqua">
                                <strong>{{ formatter.format(totalLine.sentTotal) }}€</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{ formatter.format(totalLine.draftTotal + totalLine.confirmedTotal + totalLine.sentTotal ) }}€</strong>
                            </td>
                            <td class="text-right">
                                <strong>{{ formatter.format(totalLine.totalC1) }}€</strong>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="clearfix"></div>
            <ol class="breadcrumb">
                <li>
                    <a href="#" @click.prevent="getDownline(endPoint, true); sliceBreadCrumbs(); downlineOrdersChanged()">
                        <img src="/images/app/logo-mini-2.png" class="img-responsive" style="max-width: 25px; height: auto;">
                        <span class="all-downline-orders">{{ _t('All') }}</span>
                    </a>
                </li>
                <li v-for="(breadCrumb, index) in breadCrumbs">
                    <a href="#" @click.prevent="getDownline(breadCrumb.url, false);  sliceBreadCrumbs(index); downlineOrdersChanged(breadCrumb.username, breadCrumb.user_id, breadCrumb.fullname)">{{ breadCrumb.text }}</a>
                </li>
            </ol>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['week', 'year', 'endPoint', 'locale', 'strings', 'expanded',],
        data: function () {
            return {
                downlineOrders: [],
                formatter: null,
                searchString: "",
                formatterInteger: null,
                breadCrumbs: [],
                ordersDisabled: false,
                totalLine: {
                    userActivityStatus: false,
                    massiveSending: false,
                    massiveSendingRoute: "",
                    createButton: "",
                    totalUser: "",
                    draftTotal: 0,
                    confirmedTotal: 0,
                    sentTotal: 0,
                    totalC1: 0,
                    sentCount: 0,
                    notPaidCount: 0,
                },
                user_id: null,
                consultant_group_id: null,
            }
        },
        created() {
            if(!this.week && !this.year) {
                this.ordersDisabled = true;
            }


            this.formatter = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 2
            });
            this.formatterInteger = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
        },
        mounted(){
            this.getDownline(this.endPoint, true);
        },
        methods: {
            getDownline(url, allDownlineOrders, event) {
                var _that = this;

                            _that.searchString = "";
                            _that.search();

                if(event)$(event.target).blur();

                $('.widget--downline-orders .table-container').animate({ scrollTop: 0 }, "fast");
                $('.widget--downline-orders .div-preloader').fadeIn();
                axios.get(url)
                    .then((res) => {

                        this.downlineOrders = res.data.downline_orders;

                        this.buildTotalLine(res.data);

                        if(allDownlineOrders) {
                            this.user_id = null;
                            this.consultant_group_id = null;
                        }else{
                            this.user_id = res.data.user_id;
                            this.consultant_group_id = res.data.consultant_group_id;
                        }

                        if(res.data.breadCrumbData && this.breadCrumbs.length === 0) {
                            //url, fullname, cg_external_code, username, userId, massive_send_route, massive_sending
                            this.pushBreadCrumb(res.data.breadCrumbData.url,
                                res.data.breadCrumbData.fullname,
                                res.data.breadCrumbData.consultant_group_external_code,
                                res.data.breadCrumbData.username,
                                res.data.breadCrumbData.user_id,
                                res.data.breadCrumbData.massive_send_route,
                                res.data.breadCrumbData.massive_sending,
                            );
                        }

                        Event.$emit('downlineOrdersFetched', this.user_id, this.consultant_group_id, this.breadCrumbs);

                        $('.widget--downline-orders .div-preloader').fadeOut();
                    });
            },
            search(){
                $('.widget--downline-orders .table-container').animate({ scrollTop: 0 }, "fast");
                var search_context = $(".widget--downline-orders__table tbody", $(this.$el));
                search_context.unmark();
                if(this.searchString != ""){
                    search_context.mark(this.searchString, {
                        separateWordSearch: false
                    });
                    search_context.find(".widget--downline-orders__row").hide();
                    search_context.find("mark").closest(".widget--downline-orders__row").show();
                }else{
                    search_context.find(".widget--downline-orders__row").show();
                }
            },
            buildTotalLine(data) {
                this.totalLine.totalUser = data.fullname && data.cg_external_code ? data.fullname + ' (' + data.cg_external_code  + ')' : "";
                this.totalLine.massiveSending = data.massive_sending;
                this.totalLine.massiveSendingRoute = data.massive_send_route;
                this.totalLine.createButton = data.create_button;
                this.totalLine.userActivityStatus = data.user_activity_status;
                this.totalLine.sentCount = Number(data.orders_totals.num_sent_orders);
                this.totalLine.notPaidCount = Number(data.orders_totals.num_not_paid_orders);
                this.totalLine.draftTotal = Number(data.orders_totals.total_draft_a1);
                this.totalLine.confirmedTotal = Number(data.orders_totals.total_confirmed_a1);
                this.totalLine.sentTotal = Number(data.orders_totals.total_sent_a1);
                this.totalLine.totalC1 = Number(data.orders_totals.total_c1);
            },
            pushBreadCrumb(url, fullname, cg_external_code, username, userId, massive_send_route, massive_sending) {
                let text = fullname && cg_external_code ? fullname + ' (' + cg_external_code  + ')' : null;
                this.breadCrumbs.push({
                    url: url,
                    text: text,
                    username: username || null,
                    user_id: userId || null,
                    fullname: fullname || null,
                    massive_send_route: massive_send_route || null,
                    massive_sending: massive_sending || null,
                })
             },
            sliceBreadCrumbs(index) {
                if(index || index === 0) {
                    this.breadCrumbs.length = index + 1;
                }else{
                    this.breadCrumbs = [];
                }
            },
            sendConfirmedOrders(event, route) {
                event.preventDefault();
                var _that = this;
                var currentLevelUrl = _that.endPoint;

                if(_that.breadCrumbs.length > 0) {
                    currentLevelUrl = _that.breadCrumbs[_that.breadCrumbs.length - 1 ].url;
                }

                Swal.fire({
                    text: _t('Are you sure you want to send all confirmed orders for the selected level? Once sent, the orders could no longer be modified.'),
                    icon: "warning",
                    buttonsStyling: false,
                    showCancelButton: true,
                    cancelButtonText: _t('Back'),
                    confirmButtonText: _t('Send'),
                    customClass: {
                        confirmButton: 'btn btn-info',
                        cancelButton: 'btn btn-danger',
                    }
                }).then(function (result) {
                    if(result.isConfirmed) {
                        Swal.fire({
                            text: _t('Please confirm your action. Once sent, the orders could no longer be modified.'),
                            icon: "warning",
                            buttonsStyling: false,
                            showCancelButton: true,
                            cancelButtonText: _t('Back'),
                            confirmButtonText: _t('Send'),
                            customClass: {
                                confirmButton: 'btn btn-info',
                                cancelButton: 'btn btn-danger',
                            }
                        }).then(function (result) {

                            if(result.isConfirmed) {
                                axios.post(route)
                                    .then((res) => {
                                        _that.getDownline(currentLevelUrl, false);
                                        Swal.fire({
                                            text: res.data.success,
                                            icon: "success",
                                            showCancelButton: false,
                                        });
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    })
                            }
                        })
                    }
                });
            },
            downlineOrdersChanged(consultantUsername, userId, consultantFullname) {
                consultantUsername = consultantUsername || null;
                userId = userId || null;
                consultantFullname = consultantFullname || null;
                Event.$emit('downlineOrdersChanged', consultantUsername, userId, consultantFullname);
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/widgets/downlineOrders.vue